import React from "react";
import { Table } from "react-bootstrap";

export default function BenefisInvalidTable({ errorRows, setOpenEditBenefis }) {
  const tableRowEvents = row => {
    setOpenEditBenefis(prev => ({
      ...prev,
      show: true,
      initValues: row
    }));
  };

  return (
    <>
      <Table responsive={true}>
        <thead>
          <tr>
            <th>No</th>
            <th className="text-nowrap">Nama Organisasi</th>
            <th className="text-nowrap">Nama PIC</th>
            <th className="text-nowrap">Telepon PIC</th>
            <th className="text-nowrap">Email PIC</th>
            <th className="text-nowrap">No Ktp / No Perusahaan</th>
            <th className="text-nowrap">Jumlah Anggota</th>
            <th className="text-nowrap">Kategori Penerima Manfaat</th>
            <th className="text-nowrap">Provinsi</th>
            <th className="text-nowrap">Kota</th>
            <th className="text-nowrap">Kecamatan</th>
            <th className="text-nowrap">Kode Pos</th>
            <th className="text-nowrap">Status Hidup</th>
            <th className="text-nowrap">Status Aktif</th>
          </tr>
        </thead>
        <tbody>
          {errorRows.map((item, index) => {
            return (
              <tr
                key={index}
                onClick={() => {
                  tableRowEvents(item);
                }}
                style={{ cursor: "pointer" }}
              >
                <td>{index + 1}</td>
                <td className="text-nowrap">{item.data.name}</td>
                <td className="text-nowrap">{item.data.pic_name}</td>
                <td className="text-nowrap">{item.data.pic_hp}</td>
                <td className="text-nowrap">{item.data.pic_email}</td>
                <td className="text-nowrap">{item.data.nik}</td>
                <td className="text-nowrap">{item.data.qty}</td>
                <td className="text-nowrap">{item.data.benefis_category}</td>
                <td className="text-nowrap">{item.data.province}</td>
                <td className="text-nowrap">{item.data.city}</td>
                <td className="text-nowrap">{item.data.district}</td>
                <td className="text-nowrap">{item.data.postal_code}</td>
                <td className="text-nowrap">{item.data.is_alive}</td>
                <td className="text-nowrap">{item.data.is_active}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
